/*
* Created By GiHwan Lee <devp026>
*/

export const state = () => ({
  addGetDelSecPolicyOptions: '/api/cm/vpn-policy',
  addgetSecPolicy: '/api/cm/vpn-policy-cm',
  delSecPolicy: '/api/cm/vpn-policy-cm/multi', // etc param = vpn_policy_cm_id_list : [1,2]
  cryptoUrl: '/api/cm/vpn-crypto-algr',
  authUrl: '/api/cm/vpn-auth-algr',
  dhGrpUrl: '/api/cm/vpn-dh-grp',

  // == Popup Contents ==
  cryptoOptions: [],
  authOptions: [],
  dhGrpOptions: [],
  secPopupDataList: [],
  secPopupOptions: {},
  secMainDataList: [],
  selectedItem: {},
  selectedOptionItem: [],
  newCmId: 0,
  policyPopUpData: {
    vpn_policy_cm_id: 0,
    vpn_policy_id: 0,
    p1_opt_yn: 1,
    vpn_policy_uname: '',
    vpn_policy_desc: '',
    p2_crypto_algr: {}, // 기본 설정
    p2_auth_algr: {},
    p2_dh_grp: {},
    p1_crypto_algr: {}, // 고급 설정
    p1_auth_algr: {},
    p1_dh_grp: {}
  },

  tableCondition: {
    selectedRowData: false
  }
})

export const mutations = {
  setCmId: (state, item) => {
    let cmId = 0
    if (item.result === undefined) {
      cmId = item
    } else {
      cmId = item.result.msg
    }
    state.policyPopUpData.vpn_policy_cm_id = cmId
  },

  clearDetailPopup (state) {
    state.policyPopUpData.p1_opt_yn = 1
    state.policyPopUpData.vpn_policy_uname = state.cryptoOptions[0].label + '-' +
      state.authOptions[0].label + '-' + state.dhGrpOptions[0].label.split(':')[0]
    state.policyPopUpData.vpn_policy_desc = ''
    state.policyPopUpData.p2_crypto_algr = { // 기본 설정
      vpn_crypto_algr_id: state.cryptoOptions[0].value,
      name: state.cryptoOptions[0].label
    }
    state.policyPopUpData.p2_auth_algr = {
      vpn_auth_algr_id: state.authOptions[0].value,
      name: state.authOptions[0].label
    }
    state.policyPopUpData.p2_dh_grp = {
      vpn_dh_grp_id: state.dhGrpOptions[0].value,
      name: state.dhGrpOptions[0].label
    }
    state.policyPopUpData.p1_crypto_algr = { // 고급 설정
      vpn_crypto_algr_id: state.cryptoOptions[0].value,
      name: state.cryptoOptions[0].label
    }
    state.policyPopUpData.p1_auth_algr = {
      vpn_auth_algr_id: state.authOptions[0].value,
      name: state.authOptions[0].label
    }
    state.policyPopUpData.p1_dh_grp = {
      vpn_dh_grp_id: state.dhGrpOptions[0].value,
      name: state.dhGrpOptions[0].label
    }
  },

  getSecPolicyData: (state, item) => {
    for (const device of item) {
      const result = []
      const deviceList = device.vpn_policy_cm_device
      for (const deviceId of deviceList) {
        result.push(deviceId.device_id)
      }
      device.device_id_list = result
    }
    state.secMainDataList = item
  },
  // 동기화 전체 사용/사용 안 함 적용.
  changeAllSyncYn (state, data) {
    const syncData = _.cloneDeep(state.secMainDataList)
    _.forEach(syncData, o => {
      o.vpn_policy_cm_sync_yn = data
    })
    state.secMainDataList = syncData
  },

  setSecPolicyOptionsData: (state, item = []) => {
    state.secPopupDataList = item
  },

  setSelectedItem: (state, item) => {
    state.selectedItem = item
  },

  setSelectedOptionItem: (state, item) => {
    state.selectedOptionItem = item
  },
  setSecPopupOptions: (state, item) => {
    state.secPopupOptions = item
  },
  cryptoList: (state, data) => {
    state.cryptoOptions = []
    for (const item of data.result) {
      state.cryptoOptions.push({
        label: item.vpn_crypto_algr_uname,
        value: item.vpn_crypto_algr_id
      })
    }
  },

  authList: (state, data) => {
    state.authOptions = []
    for (const item of data.result) {
      state.authOptions.push({
        label: item.vpn_auth_algr_uname,
        value: item.vpn_auth_algr_id
      })
    }
  },

  dhGrpList: (state, data) => {
    state.dhGrpOptions = []
    for (const item of data.result) {
      state.dhGrpOptions.push({
        label: item.vpn_dh_grp_uname,
        value: item.vpn_dh_grp_id
      })
    }
  },

  delSecPolicy: (state, idxList) => {
    idxList = idxList.sore().reverse()
    for (const idx of idxList) {
      state.secMainDataList.splice(idx, 1)
    }
  }
}

export const actions = {
  async applySecPolicyAction () {
    const result = await this.$axios.$put('/api/cm/vpn-policy/apply', null, {applyMsg: true, loading: true, successAlert: true})
    return result
  },
  async cancelSecPolicyAction () {
    const result = await this.$axios.$put(`/api/cm/vpn-policy/cancel`, null, {cancelMsg: true, loading: true, successAlert: true})
    return result
  },
  async getCmId ({commit, state}) {
    try {
      const data = await this.$axios.$post(state.addgetSecPolicy, null, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return false
      }
      commit('setCmId', data)
      return 'ok'
    } catch (error) {
      return false
    }
  },

  async getSecPolicyData ({commit, state}) {
    const res = {code: 'ok'}
    const {code, result} = await this.$axios.$get(state.addgetSecPolicy + '/0')
    if (code === 'ok') {
      commit('getSecPolicyData', result)
    }
    return res
  },

  async getSecPolicyOptionsData ({commit, state}, cmId) {
    try {
      const data = await this.$axios.$get(state.addGetDelSecPolicyOptions + `/${cmId}/0`)
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('setSecPolicyOptionsData', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },

  // 암호 알고리즘 리스트 조회
  async cryptoList ({commit, state, rootState}) {
    try {
      const data = await this.$axios.$get(state.cryptoUrl)
      if (data.code !== 'ok') {
        return false
      }
      // CC Enable
      const ccFlag = rootState.common.common.uiData.system.cc_flag
      if (ccFlag) {
        const cryptoFilter = [3, 4, 5, 8] // ARIA-128, ARIA-192, ARIA-256, SEED
        data.result = data.result.filter(row => cryptoFilter.indexOf(row.vpn_crypto_algr_id) !== -1)
      }
      commit('cryptoList', data)
      return 'ok'
    } catch (error) {
      return false
    }
  },

  // 인증 알고리즘 리스트 조회
  async authList ({commit, state, rootState}) {
    try {
      const data = await this.$axios.$get(state.authUrl)
      if (data.code !== 'ok') {
        return false
      }
      // CC Enable
      const ccFlag = rootState.common.common.uiData.system.cc_flag
      if (ccFlag) {
        const authFilter = [2, 4] // SHA-256, SHA-512
        data.result = data.result.filter(row => authFilter.indexOf(row.vpn_auth_algr_id) !== -1)
      }
      commit('authList', data)
      return 'ok'
    } catch (error) {
      return false
    }
  },

  // DH 그룹 리스트 조회
  async dhGrpList ({commit, state, rootState}) {
    try {
      const data = await this.$axios.$get(state.dhGrpUrl)
      if (data.code !== 'ok') {
        return false
      }
      // CC Enable
      const ccFlag = rootState.common.common.uiData.system.cc_flag
      if (ccFlag) {
        const dhGrpFilter = 3 // Group14:MODP_2048
        data.result = data.result.filter(row => row.vpn_dh_grp_id === dhGrpFilter)
      }
      commit('dhGrpList', data)
      return 'ok'
    } catch (error) {
      return error
    }
  },

  async addTableList ({ store, commit, state }) {
    const params = {}
    params.p1_opt_yn = state.policyPopUpData.p1_opt_yn
    params.p2_vpn_auth_algr_id = state.policyPopUpData.p2_auth_algr.vpn_auth_algr_id // 기본 설정
    // params.p2_crypto_auth_algr_id = state.policyPopUpData.p2_crypto_algr.vpn_crypto_algr_id
    params.p2_vpn_crypto_algr_id = state.policyPopUpData.p2_crypto_algr.vpn_crypto_algr_id
    params.p2_vpn_dh_grp_id = state.policyPopUpData.p2_dh_grp.vpn_dh_grp_id
    params.p1_vpn_auth_algr_id = state.policyPopUpData.p1_auth_algr.vpn_auth_algr_id // 고급 설정
    // params.p1_crypto_auth_algr_id = state.policyPopUpData.p1_crypto_algr.vpn_crypto_algr_id
    params.p1_vpn_crypto_algr_id = state.policyPopUpData.p1_crypto_algr.vpn_crypto_algr_id
    params.p1_vpn_dh_grp_id = state.policyPopUpData.p1_dh_grp.vpn_dh_grp_id
    params.vpn_policy_cm_id = state.policyPopUpData.vpn_policy_cm_id
    params.vpn_policy_desc = state.policyPopUpData.vpn_policy_desc
    params.vpn_policy_uname = state.policyPopUpData.vpn_policy_uname

    try {
      const data = await this.$axios.$post(state.addGetDelSecPolicyOptions, params, {successAlert: false})
      if (data.code !== 'ok') {
        return data
      }
      return 'ok'
    } catch (error) {
      return error
    }
  },

  async edtTableList ({ store, commit, state }) {
    const params = {}
    params.p1_opt_yn = state.policyPopUpData.p1_opt_yn
    params.p2_vpn_auth_algr_id = state.policyPopUpData.p2_auth_algr.vpn_auth_algr_id // 기본 설정
    // params.p2_crypto_auth_algr_id = state.policyPopUpData.p2_crypto_algr.vpn_crypto_algr_id
    params.p2_vpn_crypto_algr_id = state.policyPopUpData.p2_crypto_algr.vpn_crypto_algr_id
    params.p2_vpn_dh_grp_id = state.policyPopUpData.p2_dh_grp.vpn_dh_grp_id
    params.p1_vpn_auth_algr_id = state.policyPopUpData.p1_auth_algr.vpn_auth_algr_id // 고급 설정
    params.p1_vpn_crypto_algr_id = state.policyPopUpData.p1_crypto_algr.vpn_crypto_algr_id
    params.p1_vpn_dh_grp_id = state.policyPopUpData.p1_dh_grp.vpn_dh_grp_id
    params.vpn_policy_id = state.selectedOptionItem.vpn_policy_id
    params.vpn_policy_desc = state.policyPopUpData.vpn_policy_desc
    params.vpn_policy_uname = state.policyPopUpData.vpn_policy_uname
    try {
      const data = await this.$axios.$put(state.addGetDelSecPolicyOptions, params, {successAlert: false})
      if (data.code !== 'ok') {
        return data
      }
      return 'ok'
    } catch (error) {
      return error
    }
  },

  async addSecPolicy ({commit, state}) {
    try {
      const param = state.secPopupOptions
      const data = await this.$axios.$put(state.addgetSecPolicy, param, {successAlert: false})
      if (data.code !== 'ok') {
        return data
      }
      return 'ok'
    } catch (error) {
      return error
    }
  },

  async delSecPolicy ({commit, state}, param) {
    try {
      let data = null
      if (_.isUndefined(param[1])) {
        data = await this.$axios.$put(state.delSecPolicy, param[0], {loading: false, successAlert: false})
      } else {
        data = await this.$axios.$put(state.delSecPolicy, param[0], {successAlert: false})
      }
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async delSecPolicyOptions ({commit, state}, id) { // 멀티 삭제 기능 아님.
    try {
      const data = await this.$axios.$delete(state.addGetDelSecPolicyOptions + `/${id}`)
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async chgRadioBtn ({commit, state}, param) {
    try {
      const data = await this.$axios.$put(state.addGetDelSecPolicyOptions + `/${param[0]}/${param[1]}`, null, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return false
      }
      return 'ok'
    } catch (error) {
      return error
    }
  },
  async onEventRuleChkInputAxios ({commit, state}, param) {
    try {
      const data = await this.$axios.$post(state.delSecPolicy, param, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return false
      }
      return data
    } catch (error) {
      return error
    }
  }
}

export const string = false
